import { ReactNode, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { personalDataStore } from 'stores/personalDataStore';

interface PersonalDataProviderProps {
  children: ReactNode;
}

export const PersonalDataProvider = observer(({ children }: PersonalDataProviderProps) => {
  const { user, userLoading } = personalDataStore;

  useEffect(() => {
    // Если есть данные пользователя, но PersonalData пустые - заполняем их
    if (user && !personalDataStore.data.id) {
      personalDataStore.setFromUser(user);
    }
  }, [user]);

  // Показываем children только если PersonalData загружены или загружаются
  if (userLoading) {
    return null;
  }

  return <>{children}</>;
});
